import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=6109c6e6&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/thesheps/code/tags/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRating } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VDataTable,VIcon,VRating,VSnackbar})
